import React from "react";
import styles from "../../css/receiveStock.module.css";
import layoutStyles from "../../css/receiveStockLayout.module.css";
import Navbar from "../../../../../components/navbar";
import Footer from "../../../../../components/footer";
import DispensaryForm from "../DispensaryForm";
import FrontShopForm from "../FrontShopForm";
import ScanBarcodeCard from "../ScanBarcodeCard.jsx";
import ScanModeSwitch from "../ScanModeSwitch.jsx";
import FilterButtons from "../../../../../components/universal-filter-tabs.jsx";
import SuccessNotification from "../../../../../components/SuccessNotification";

export default function ReceiveStockBody({
  roleId,
  activeTab,
  handleTabChange,
  entryMode,
  setEntryMode,
  dispensaryType,
  setDispensaryType,
  itemType,
  setItemType,
  frontShopType,
  setFrontShopType,
  otcType,
  setOtcType,
  otherCategorySelected,
  setOtherCategorySelected,
  categories,
  suppliers,
  errors,
  handleFormSubmit,
  showSuccess,
  setShowSuccess,
  scanBarcode,
  onScanChange,
  scanDrug,
  scanItem,
  selectedType,
  scanReturnOnSave,
}) {
  return (
    <div className={styles.wrapper}>
      <Navbar />
      <div className={styles.dashboardLayout}>
        <main className={styles.main}>
          <div className={styles.container}>
            <div className={`${styles.headerRow} ${layoutStyles.headerRowRelative}`}>
              <h1 className={styles.title}>Receive Stock</h1>
              {roleId !== 6 && (
                <>
                  <div
                    className={`${styles.tabRow} ${layoutStyles.tabRowColumnCenter}`}
                  >
                    {/* Row 1: main segment tabs + scan mode switch */}
                    <div className={layoutStyles.segmentTabsOuterRow}>
                      <div className={layoutStyles.segmentTabsWrapper}>
                        <FilterButtons
                          buttons={["Dispensary", "Front Shop", "OTC", "Clinic"]}
                          activeButton={activeTab}
                          onButtonClick={handleTabChange}
                          className={styles.segmentTabs}
                        />

                        {!(entryMode === "Manual" && scanReturnOnSave) && (
                          <div
                            className={`${styles.itemTypeDropdownInline} ${layoutStyles.scanModeSwitchInline}`}
                          >
                            <ScanModeSwitch entryMode={entryMode} setEntryMode={setEntryMode} />
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Row 2: Item / Drug selector directly below main tabs */}
                    {activeTab === "Dispensary" && (
                      <div
                        className={`${styles.itemTypeDropdownInline} ${layoutStyles.itemTypeDropdownRow}`}
                      >
                        <FilterButtons
                          buttons={["Item", "Drug"]}
                          activeButton={dispensaryType}
                          onButtonClick={setDispensaryType}
                          className={styles.segmentTabs}
                        />
                      </div>
                    )}

                    {activeTab === "Clinic" && (
                      <div
                        className={`${styles.itemTypeDropdownInline} ${layoutStyles.itemTypeDropdownRow}`}
                      >
                        <FilterButtons
                          buttons={["Item", "Drug"]}
                          activeButton={itemType}
                          onButtonClick={setItemType}
                          className={styles.segmentTabs}
                        />
                      </div>
                    )}

                    {activeTab === "Front Shop" && (
                      <div
                        className={`${styles.itemTypeDropdownInline} ${layoutStyles.itemTypeDropdownRow}`}
                      >
                        <FilterButtons
                          buttons={["Item", "Drug"]}
                          activeButton={frontShopType}
                          onButtonClick={setFrontShopType}
                          className={styles.segmentTabs}
                        />
                      </div>
                    )}

                    {activeTab === "OTC" && (
                      <div
                        className={`${styles.itemTypeDropdownInline} ${layoutStyles.itemTypeDropdownRow}`}
                      >
                        <FilterButtons
                          buttons={["Item", "Drug"]}
                          activeButton={otcType}
                          onButtonClick={setOtcType}
                          className={styles.segmentTabs}
                        />
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>

            {entryMode === "Scan" ? (
              selectedType ? (
                <ScanBarcodeCard value={scanBarcode} onChange={onScanChange} />
              ) : (
                <div className={styles.scanTypeHint}>
                  {/* Hint intentionally left blank; caller may customize text if needed */}
                </div>
              )
            ) : (
              <>
                {activeTab === "Dispensary" && roleId !== 6 && (
                  <>
                    {dispensaryType === "" ? null : dispensaryType === "Drug" ? (
                      <DispensaryForm
                        otherCategorySelected={otherCategorySelected}
                        onOtherCategoryChange={setOtherCategorySelected}
                        onSubmit={handleFormSubmit}
                        departmentName={activeTab}
                        categories={categories}
                        errors={errors}
                        scanDrug={scanDrug}
                      />
                    ) : (
                      <FrontShopForm
                        onSubmit={handleFormSubmit}
                        categories={categories}
                        suppliers={suppliers}
                        errors={errors}
                        departmentName={activeTab}
                        scanItem={scanItem}
                      />
                    )}
                  </>
                )}

                {activeTab === "Clinic" && (
                  <>
                    {roleId === 6 ? (
                      // Clinic-only: show Drug form by default, no filter
                      <DispensaryForm
                        otherCategorySelected={otherCategorySelected}
                        onOtherCategoryChange={setOtherCategorySelected}
                        onSubmit={handleFormSubmit}
                        departmentName={activeTab}
                        categories={categories}
                        errors={errors}
                        scanDrug={scanDrug}
                      />
                    ) : (
                      <>
                        {itemType === "" ? null : itemType === "Item" ? (
                          <FrontShopForm
                            onSubmit={handleFormSubmit}
                            categories={categories}
                            suppliers={suppliers}
                            errors={errors}
                            scanItem={scanItem}
                          />
                        ) : (
                          <DispensaryForm
                            otherCategorySelected={otherCategorySelected}
                            onOtherCategoryChange={setOtherCategorySelected}
                            onSubmit={handleFormSubmit}
                            departmentName={activeTab}
                            categories={categories}
                            errors={errors}
                            scanDrug={scanDrug}
                          />
                        )}
                      </>
                    )}
                  </>
                )}

                {activeTab === "Front Shop" && roleId !== 6 && (
                  <>
                    {frontShopType === "" ? null : frontShopType === "Item" ? (
                      <FrontShopForm
                        plusShift
                        onSubmit={handleFormSubmit}
                        categories={categories}
                        suppliers={suppliers}
                        errors={errors}
                        departmentName={activeTab}
                        scanItem={scanItem}
                      />
                    ) : (
                      <DispensaryForm
                        otherCategorySelected={otherCategorySelected}
                        onOtherCategoryChange={setOtherCategorySelected}
                        onSubmit={handleFormSubmit}
                        departmentName={activeTab}
                        categories={categories}
                        errors={errors}
                        scanDrug={scanDrug}
                      />
                    )}
                  </>
                )}

                {activeTab === "OTC" && roleId !== 6 && (
                  <>
                    {otcType === "" ? null : otcType === "Drug" ? (
                      <DispensaryForm
                        otherCategorySelected={otherCategorySelected}
                        onOtherCategoryChange={setOtherCategorySelected}
                        onSubmit={handleFormSubmit}
                        departmentName={activeTab}
                        categories={categories}
                        errors={errors}
                        scanDrug={scanDrug}
                      />
                    ) : (
                      <FrontShopForm
                        onSubmit={handleFormSubmit}
                        categories={categories}
                        suppliers={suppliers}
                        errors={errors}
                        scanItem={scanItem}
                      />
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </main>
      </div>
      <Footer />
      {showSuccess && (
        <SuccessNotification
          message="Successfully added to inventory!"
          onClose={() => setShowSuccess(false)}
        />
      )}
    </div>
  );
}
